'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  contentBlank: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool
};
var defaultProps = {
  expanded: false,
  contentBlank: false
};

var size = function size(_ref) {
  var themeFromProvider = _ref.theme,
      contentBlank = _ref.contentBlank;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.accordion.item.content,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX;
  return !contentBlank && (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
};

var expanded = function expanded(_ref2) {
  var themeFromProvider = _ref2.theme,
      expanded = _ref2.expanded;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  return expanded ? '\n      pointer-events: auto;\n      opacity: 1;\n      position: relative;\n      z-index: 1;\n      transform: translateY(0);\n    ' : (0, _styledComponents.css)(['transform:translateY(', ');pointer-events:none;opacity:0;position:fixed;z-index:-1;'], (0, _reactackleCore.getValueString)(theme.reactackle.components.accordion.item.content.animatedOffset));
};

var ContentStyled = exports.ContentStyled = _styledComponents2.default.dd.withConfig({
  displayName: 'ContentStyled'
})(['margin:0;', ' ', ' ', ''], size, expanded, (0, _reactackleCore.transition)('transform'));

ContentStyled.propTypes = propTypes;
ContentStyled.defaultProps = defaultProps;